// extracted by css-extract-rspack-plugin
export default {"cls1":"SelectionCitation-cls1_Nmi","cls2":"SelectionCitation-cls2_u8b SelectionCitation-cls1_Nmi"};